import { render, staticRenderFns } from "./memberMove.vue?vue&type=template&id=9b9a326a&scoped=true&"
import script from "./memberMove.vue?vue&type=script&lang=js&"
export * from "./memberMove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b9a326a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2025/DiTuYouXuan/DiTuAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b9a326a')) {
      api.createRecord('9b9a326a', component.options)
    } else {
      api.reload('9b9a326a', component.options)
    }
    module.hot.accept("./memberMove.vue?vue&type=template&id=9b9a326a&scoped=true&", function () {
      api.rerender('9b9a326a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/member/memberManage/memberMove.vue"
export default component.exports